<template>
  <div class="inline-block">
    <img v-if="hasImage && photoStatus == 'approved'" :class="computedClasses" :src="imageUrl" :alt="avatarAlt" />
    <div
      v-else-if="photoUploadIcon"
      aria-hidden="true"
      :class="`${computedClasses} bg-grey-divider-subdued text-grey-clickable font-medium flex items-center justify-center`"
    >
      <photo-icon :height="photoUploadDimensions.height" :width="photoUploadDimensions.width" color="#4B4C52" />
    </div>
    <div
      v-else
      aria-hidden="true"
      :class="`${computedClasses} bg-grey-divider-subdued text-grey-clickable font-medium flex items-center justify-center`"
    >
      <span :class="textClasses">{{ placeholderInitials }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import PhotoIcon from '../../graphics/icons/PhotoIcon.vue';

export default {
  name: 'Avatar',
  components: {
    PhotoIcon,
  },
  props: {
    imageUrl: {
      type: String || null,
      default: null,
    },
    size: {
      type: String!,
      default: 'base',
    },
    name: {
      type: String,
      required: true,
    },
    photoStatus: {
      type: String,
      default: 'approved',
    },
    photoUploadIcon: {
      type: Boolean,
      default: false,
    },
    emptyAlt: {
      type: Boolean,
      default: false,
    },
    customClasses: {
      type: String,
      default: '',
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedClasses(): string {
      const baseClasses = this.customClasses || this.sizeClasses;
      const roundedClass = this.rounded ? ' rounded-full' : '';
      return `${baseClasses}${roundedClass}`;
    },
    textClasses(): string {
      if (this.size === 'medium') {
        return 'text-m';
      }
      if (this.size === 'large' || this.size === 'xl') {
        return 'text-m2';
      }
      if (this.size === 'mega') {
        return 'text-l';
      }
      return 'text-xs';
    },
    photoUploadDimensions(): any {
      if (this.size === 'medium') {
        return { width: 16, height: 12 };
      }
      if (this.size === 'large') {
        return { width: 24, height: 18 };
      }
      if (this.size === 'xl') {
        return { width: 32, height: 24 };
      }
      if (this.size === 'mega') {
        return { width: 48, height: 36 };
      }
      return { width: 12, height: 9 };
    },
    sizeClasses(): string {
      if (this.size === 'medium') {
        return 'w-32 h-32';
      }
      if (this.size === 'large') {
        return 'w-48 h-48';
      }
      if (this.size === 'xl') {
        return 'w-64 h-64';
      }
      if (this.size === 'mega') {
        return 'w-96 h-96';
      }
      return 'w-24 h-24';
    },
    hasImage(): boolean {
      return !!this.imageUrl;
    },
    placeholderInitials(): string {
      const regex = /^([A-Za-z])[^\s]+\s+([A-Za-z])/;
      const m = this.name.match(regex);
      if (m === null) {
        return this.name.charAt(0).toUpperCase();
      }
      return m[1].toUpperCase() + m[2].toUpperCase();
    },
    avatarAlt(): string {
      return this.emptyAlt ? '' : `Avatar of ${this.name}`;
    },
  },
};
</script>
